/* import __COLOCATED_TEMPLATE__ from './prism-text-tooltip.hbs'; */
import { equal } from '@ember/object/computed';
import Component from '@ember/component';
import { computed } from '@ember/object';
import { next } from '@ember/runloop';

/**
 * Renders a link which toggles a tooltip.
 *
 * ```hbs
 * {{prism-text-tooltip
 *    linkText="Click me to learn more."
 *    tooltipText="This is helpful tooltip content!"}}
 * ```
 *
 * @class PrismTextTooltip
 */
export default Component.extend({
  classNames: ['prism-text-tooltip'],
  /**
   * Text to act as the trigger for the tooltip instead of an icon.
   *
   * @argument linkText
   * @type {String}
   */
  linkText: null,
  /**
   * String to display within the rendered tooltip.
   *
   * @argument tooltipText
   * @type {String}
   */
  tooltipText: null,
  /**
   * Determines the position of the tooltip. Can be `left` or `right`.
   *
   * @argument tooltipPosition
   * @type {String}
   */
  tooltipPosition: 'left',
  /**
   * Class string to apply to the link text
   *
   * @argument linkTextClass
   * @type {String}
   */
  linkTextClass: null,
  /**
   * Class string to apply to the selected state link text.
   *
   * @argument linkTextSelectedClass
   * @type {String}
   */
  linkTextSelectedClass: null,
  showTooltip: false,
  mouseIsHovering: false,
  isLeft: equal('tooltipPosition', 'left'),
  tooltipBubbleClasses: computed('tooltipPosition', function () {
    const classes = ['prism-form-info-tooltip__bubble', `prism-form-info-tooltip__bubble--${this.tooltipPosition}`];
    return classes.join(' ');
  }),
  textClass: computed('linkTextClass', function () {
    // This prevents an issue where the blue bottom border wasn't being
    // completely overridden by the new class, so there was a faint blue
    // visible beneath the border
    return this.linkTextClass || 'prism-text-tooltip__link';
  }),
  selectedTextClass: computed('linkTextSelectedClass', function () {
    return this.linkTextSelectedClass || 'prism-text-tooltip__link--selected';
  }),
  show() {
    next(() => {
      this.set('showTooltip', true);
    });
  },
  hide() {
    if (this.isDestroyed || this.isDestroying) {
      return;
    }
    this.set('showTooltip', false);
  },
  toggleBubble() {
    if (this.showTooltip) {
      this.hide();
    } else {
      this.show();
    }
  },
  clickLink() {
    if (this.mouseIsHovering && this.userAgent.device.isDesktop) {
      this.show();
    } else {
      this.toggleBubble();
    }
  },
  mouseHoverShow() {
    this.set('mouseIsHovering', true);
    if (this.userAgent.device.isDesktop) {
      this.show();
    }
  },
  mouseHoverHide() {
    this.set('mouseIsHovering', false);
    if (this.userAgent.device.isDesktop) {
      this.hide();
    }
  }
});